<template>
  <header-menu :title="'作品详情'" :tip="''" />
  <div class="info" v-if="data.imgInfo">
    <van-swipe
      :autoplay="3000"
      @change="data.change"
      lazy-render
      :show-indicators="false"
    >
      <van-swipe-item
        class="item"
        v-for="image in data.imgInfo.image_detail"
        :key="image"
      >
        <img
          :src="
            data.flage
              ? image +
                '?x-oss-process=image/resize,w_100/watermark,type_d3F5LXplbmhlaQ,size_20,text_6Iqx6ZuGQUnnsr7ngbUK,color_8368FC,t_100,g_se,x_10,y_10'
              : image
          "
          @click="data.quitImg(image)"
        />
      </van-swipe-item>
    </van-swipe>
    <div class="name">
      <div>标题：</div>
      <div class="text">
        {{ data.imgInfo.name }}
      </div>
    </div>
    <div class="nickname">
      <div class="cname">
        <img v-if="data.imgInfo.avatar" :src="data.imgInfo.avatar" alt="">
        <img v-else-if="!data.flage" :src="data.userInfo.avatar" alt="">
         <img v-else src="@/assets/userActive.png" alt="">
        作者：</div>
      <div class="text">
        {{ data.imgInfo.nickname }}
      </div>
    </div>
  </div>
  <div class="bottom" v-if="data.imgInfo">
    <div class="btn" :style="data.flage?'':'width:100%;'" @click="data.quit(data.imgInfo)">
      一键创作同款<span>
        ({{ Number(data.imgInfo.petal_price) + "花瓣/次" }})</span
      >
    </div>
    <div class="shear"  v-if="data.flage" @click="data.shares" >
      <img src="@/assets/indexShare.png" alt="" />
      分享
    </div>
    <div v-if="data.flage" class="giveLike" @click="data.setLikeGallery(data.imgInfo)">
      <img
        v-if="data.imgInfo.is_like === 0"
        src="@/assets/quietMind.png"
        alt=""
      />
      <img v-else src="@/assets/redMind.png" alt="" />
      {{ data.getlickText(data.imgInfo.likes) }}
    </div>
  </div>
  <van-overlay
    class="bottomOverlay"
    :show="data.overlayShow"
    @click="data.overlayShow = false"
  >
    <div class="overlayImg">
      <img
        :src="
          data.flage
            ? data.overlayImg +
              '?x-oss-process=image/watermark,type_d3F5LXplbmhlaQ,size_20,text_6Iqx6ZuGQUnnsr7ngbUK,color_8368FC,t_100,g_se,x_10,y_10'
            : data.overlayImg
        "
        alt=""
      />
    </div>
    <img
      v-if="!data.flage"
      class="imgDownLoad"
      @click="data.down"
      src="@/assets/imgDownLoad.png"
      alt=""
    />
  </van-overlay>
  <van-popup class="sharesPopup" :show="data.sharesShow" @open='data.sharsUrl = null' round>
    <div class="shares">
      <div class="cavers" ref="shares">
        <div class="header">
          {{ data.imgInfo.app_name }}
        </div>
        <div class="tip">
          {{ data.imgInfo.app_desc }}
        </div>
        <div class="sharsImg"><img :src="data.sharsImg" alt="" /></div>
        <div class="qrcode">
          <div>
            <div class="title">花集AI</div>
            <div class="samll">让天下没有难用的AI</div>
          </div>
          <div class="code">
            <img :src="data.qrcode" alt="" />
          </div>
        </div>
      </div>
      <div class="bottom">
        <div @click="data.copyLink"
        class="copyBtn"
        :data-clipboard-text="data.url">
          <img src="@/assets/imgInfolink.png" alt="" />复制链接
        </div>
        <div @click="data.saveImg" :style="data.sharsUrl ? '' : 'opacity:.8'">
          <img src="@/assets/saveIcon.png" alt="" />保存图片
        </div>
      </div>
      <div class="close" @click="data.sharesShow = false">
        <img src="@/assets/sharesCloes.png" alt="" />
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import { again, undateImg } from "@/api/img";
import { appDeteil } from "@/api/text";
import { lickgalley } from "@/api/home";
import { showToast } from "vant";
import share from "m-share";
import headerMenu from "@/components/headerMenu.vue";
import html2canvas from "html2canvas";
import { teamCode } from "@/api/invite";
import { showFailToast } from "vant";
import ClipboardJS from "clipboard";
import { getToken } from "@/ulits/auth";
import { showNotify } from "vant";
import cross from "@/assets/cross.png";
const QRCode = require("qrcode");
const store = useCounterStore();
const route = useRoute();
const router = useRouter();
const data = reactive({});
data.flage = route.query.type ? true : false;
data.overlayImg = "";
data.imgIndex = 0;
data.sharsImg = null;
data.likeGalleryFlag = true;
data.sharsUrl = null;
data.overlayShow = false;
data.url = null

const shares = ref(null);

data.imgInfo = JSON.parse(localStorage.getItem("imgInfo"));
let userInfo = localStorage.getItem("userInfo");
if (userInfo) {
  data.userInfo = JSON.parse(userInfo)
}
if (!data.imgInfo) {
  router.replace({
    path:'/'
  })
}
data.shareWx = () => {
  share.to("wx");
};
data.down = () => {
  let a = document.createElement("a");
  a.href = data.overlayImg;
  a.download = "AI图片";
  a.click();
};
data.quitImg = (e) => {
  data.overlayImg = e;
  data.overlayShow = true;
};
(data.quit = (e) => {
  let userInfo = localStorage.getItem("userInfo");
  if (!userInfo) {
    showFailToast({
      message: "请先登录",
      icon: cross,
    });
    router.push({
      name: "login",
    });
  }
  again({
    app_id: e.app_id,
    chat_id: e.same_model_id,
    is_open: JSON.parse(userInfo).is_info_public,
  }).then((res) => {
    if (res.code === 200) {
      appDeteil({ app_id: e.app_id }).then((res) => {
        store.setGenerate(false);
        store.setCreateFlag(false);
        store.setAppInfo(res.data);
        store.copywritingFalse();
        localStorage.setItem("appInfo", JSON.stringify(res.data));
        router.push({ name: "appliance" });
      });
    }
  });
}),
  (data.getlickText = (e) => {
    let text = "";
    if (e === 0) {
      text = "赞";
    } else if (e < 10000) {
      text = e;
    } else {
      text = data.toFixedWithoutRounding(e / 10000, 1) + "万";
    }
    return text;
  });

data.toFixedWithoutRounding = (n, fixed) => {
  let multiplier = Math.pow(10, fixed);
  n = Math.floor(n * multiplier) / multiplier;
  return n.toFixed(fixed);
};

data.setLikeGallery = (e) => {
  let userInfo = localStorage.getItem("userInfo");
  if (userInfo && getToken()) {
    if (data.likeGalleryFlag) {
      data.likeGalleryFlag = false;
      lickgalley({ id: e.id })
        .then((res) => {
          if (res.code === 200) {
            if (e.is_like === 0) {
              e.is_like = 1;
              e.likes = e.likes + 1;
            } else {
              e.is_like = 0;
              e.likes = e.likes - 1;
            }
            localStorage.setItem('imgInfo',JSON.stringify(data.imgInfo))
            store.setImgDate(data.imgInfo)
          }
        })
        .finally(() => {
          data.likeGalleryFlag = true;
        });
    }
  } else {
    showFailToast({
      message: "请先登录",
      icon: cross,
    });
  }
};

data.change = (e) => {
  data.imgIndex = e;
};

data.copyLink = () => {
  const clipboard = new ClipboardJS(".copyBtn");
  clipboard.on("success", () => {
    showNotify({ type: "success", message: "复制成功" });
  });
  clipboard.on("error", () => {
    showNotify({ type: "danger", message: "复制失败" });
  });
};

data.shares = (e) => {
  teamCode().then((res) => {
    if (res.code === 200) {
      data.url =
        "https://" +
        location.hostname +
        "/appliance?id=" +
        data.imgInfo.app_id +
        "&invite_code=" +
        res.data.code;
      QRCode.toDataURL(data.url).then((res) => {
        data.qrcode = res;
        data.sharsImg = data.imgInfo.image_detail[data.imgIndex];
        data.sharesShow = true;
        setTimeout(() => {
          html2canvas(shares.value, {
            // scale: 1,
            // allowTaint: true,
            useCORS: true,
          }).then((canvas) => {
            const sharsUrl = canvas.toDataURL("image/png");
            undateImg(data.base64ToFile(sharsUrl, "newfile.png")).then(
              (res) => {
                data.sharsUrl = res.url;
                if (/android/i.test(navigator.userAgent)) {
                  wx.onMenuShareAppMessage({
                    title: data.imgInfo.app_name,
                    desc: data.imgInfo.app_desc,
                    link: res.url,
                    imgUrl: res.url,
                  });
                }
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                  wx.updateAppMessageShareData({
                    title: data.imgInfo.app_name,
                    desc: data.imgInfo.app_desc,
                    link: res.url,
                    imgUrl: res.url,
                  });
                }
              }
            );
          });
        });
      });
    }
  });
};

data.saveImg = () => {
  if (data.sharsUrl) {
    let a = document.createElement("a");
    a.href = data.sharsUrl;
    a.download = "AI";
    a.click();
  } else {
    showToast("正在生成图片");
  }
};

data.base64ToFile = (base64, fileName) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};

// 获取照片详情
onBeforeMount(() => {});
onMounted(() => {
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.info {
  color: #fff;
  padding: 0 24px;
  padding-top: 20px;
  height: calc(100vh - 280px);
  overflow: hidden;
  overflow-y: auto;
  .name {
    font-weight: 500;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .van-swipe {
    border-radius: 30px;
  }
  .nickname {
    margin-top: 24px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .cname {
      display: flex;
      align-items: center;
    }
     img {
      width: 36px;
      height: 36px;
      margin-right:10px;
      border-radius: 36px;
      background: #2d2e47;
     }
  }
  .item {
    position: relative;
    border-radius: 30px;
    img {
      border-radius: 30px;
      width: 100%;
      height: auto;
    }
    .watermark {
      position: absolute;
      bottom: 20px;
      right: 10px;
      color: #8368fc50;
      font-size: 24px;
    }
  }
  .text {
    font-size: 30px;
    font-weight: 400;
  }
}
.info::-webkit-scrollbar {
  width: 0 !important;
}

.bottom {
  padding: 0 48px;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn {
    padding: 0 25px;
    border-radius: 49px;
    height: 88px;
    background: #8368fc;
    color: #ffffff;
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    line-height: 88px;
    margin-top: 20px;
    margin-bottom: 30px;
    span {
      font-size: 24px;
    }
  }
  .shear {
    display: flex;
    align-items: center;
    font-weight: 400;
    color: #f7f5ff;
    font-size: 28px;
    img {
      margin-right: 8px;
      width: 44px;
      height: 44px;
    }
  }
  .giveLike {
    display: flex;
    align-items: center;
    font-size: 28px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #f7f5ff;
    img {
      margin-right: 4px;
      width: 44px;
      height: 44px;
    }
  }
}
.overlayImg {
  width: 100%;
  margin-top: 120px;
  position: relative;
  img {
    width: 100%;
  }
  .watermark {
    position: absolute;
    bottom: 20px;
    right: 10px;
    color: #8368fc50;
    font-size: 24px;
  }
}
.bottomOverlay {
  background: #000;
}
.imgDownLoad {
  position: absolute;
  bottom: 60px;
  right: 30px;
}
.shares {
  width: 100%;
  padding-top: 60px;
  .cavers {
    width: 100%;
    padding-bottom: 44px;
    background: url("~@/assets/shares.png") no-repeat;
    background-size: 232px 232px;
    background-position: top right;
    background-color: #daeefd;
    border-radius: 48px;
    .header {
      padding: 0 32px;
      padding-top: 58px;
      // background-image: linear-gradient(
      //     182deg,
      //     rgba(71, 140, 247, 1) 0,
      //     rgba(131, 104, 252, 1) 100%
      //   );
      overflow-wrap: break-word;
      color: rgba(21, 60, 228, 1);
      font-size: 56px;
      font-family: MyCustomFont, sans-serif;
      text-align: justify;
      white-space: nowrap;
      line-height: 63px;
      margin-left: 2px;
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .tip {
      padding: 0 32px;
      padding-top: 14px;
      font-size: 28px;
      font-weight: 400;
      color: #8368fc;
    }
    .sharsImg {
      padding: 28px;
      img {
        border-radius: 28px;
        width: 100%;
        height: 100%;
      }
    }
    .center {
      margin: 32px;
      padding: 28px;
      background: #ffffff;
      border-radius: 24px;
    }
    .item {
      margin-top: 32px;
      display: flex;
      .sharesActive {
        width: 88px;
        height: 88px;
        border-radius: 288px;
        background: #d8d8d8;
      }
      .sharesText {
        margin-left: 16px;
        width: calc(100% - 102px);
        padding: 20px;
        border-radius: 24px;
        color: #8368fc;
        background: #e5dffe;
        font-size: 28px;
      }
    }
    .item:first-child {
      margin-top: 0;
      .sharesText {
        color: #ffffff;
        line-height: 40px;
        background: #8368fc;
      }
    }
    .qrcode {
      margin: 32px;
      margin-top: 0;
      background: #ffffff;
      border-radius: 24px;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-weight: 500;
        color: #222222;
        font-size: 28px;
      }
      .samll {
        font-weight: 300;
        color: #666666;
        font-size: 24px;
      }
      .code {
        img {
          width: 110px;
          height: 110px;
        }
      }
    }
  }
  .bottom {
    color: #ffffff;
    font-size: 30px;
    display: flex;
    background: transparent;
    justify-content: space-around;
    margin-top: 36px;
    div {
      display: flex;
      align-items: center;
      background: #8368fc;
      border-radius: 24px;
      padding: 23px 28px;
    }
    img {
      width: 48px;
      height: 48px;
    }
  }
  .close {
    position: relative;
    text-align: center;
    margin-top: 33px;
    img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
<style>
.sharesPopup {
  background: transparent !important;
}
.sharesPopup::-webkit-scrollbar {
  display: none;
}
</style>
